<template>
    <div id="faceRecognition">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <img src="../../assets/img/ristWarning/人脸识别扫光.png" class="lineImg"/>
                <div class="content">
                    <div class="contentTitle">人脸识别</div>
                    <div class="contentVal">
                        <span>人脸检测与属性分析</span>
                        <span>人脸1：1对比、人脸监测校验能力服务</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即申请</button>
                </div>
            </div>
            <!--定位按钮区域-->
            <div class="btnWrap">
                <span @click="btnEvent(1)" :class="btnIndex === 1 ? 'active' : '' ">API文档</span>
                <span @click="btnEvent(2)" :class="btnIndex === 2 ? 'active' : '' ">错误码参照</span>
                <span @click="btnEvent(3)" :class="btnIndex === 3 ? 'active' : '' ">示例代码</span>
                <span @click="btnEvent(4)" :class="btnIndex === 4 ? 'active' : '' ">联系我们</span>
            </div>
        </div>
        <!--内容区-->
        <router-view/>
        <!--相关产品-->
        <div class="relevantProduct">
            <div class="relevantProductTitle">相关产品</div>
            <!--产品列表-->
            <div class="relevantProductListWrap">
                <!--@click="toPage('/InformationCheck')"-->
                <div class="relevantProductList" style="margin-right: 98px;cursor: not-allowed;opacity: 0.3">
                    <img src="../../assets/img/bigIcon/信息核验.png"/>
                    <span>信息核验</span>
                </div>
                <div class="relevantProductList" @click="toPage('/riskWarningReport')" style="margin-right: 82px;">
                    <img src="../../assets/img/bigIcon/风控.png"/>
                    <span>风险预警报告</span>
                </div>
                <!--@click="toPage('/RiskListFiltering')"-->
                <div class="relevantProductList" style="cursor: not-allowed;opacity: 0.3">
                    <img src="../../assets/img/bigIcon/风险名单过滤.png"/>
                    <span>风险名单过滤</span>
                </div>
            </div>
        </div>
        <!--弹框-->
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "faceRecognition",
        data() {
            return {
                btnIndex: 1,
                showAlertFlag: false,
            }
        },
        created() {
            this.btnEvent(1);
            this.eventBus.$on("FapiClick", () => {
                this.showAlertFlag = true;
            })
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            btnEvent(index) {
                this.btnIndex = index;
                switch (index) {
                    case 1:
                        this.$router.push({path: "/faceApiDocument"});
                        break;
                    case 2:
                        this.$router.push({path: "/faceErrorCode"});
                        break;
                    case 3:
                        this.$router.push({path: "/faceExampleCode"});
                        break;
                    case 4:
                        this.showAlertFlag = true;
                        break;
                }
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
            this.eventBus.$off("FapiClick");
        }
    }
</script>

<style lang="scss" scoped>
    #faceRecognition {
        .bannerWrap {
            background: url("../../assets/img/ristWarning/人脸识别banner.png") no-repeat center;
            background-color: #000F21;

            .content {
                margin-top: -8px;
            }
        }

        .contentWrap {
            position: relative;

            .lineImg {
                position: absolute;
                right: 205px;
                animation: lineAnimate 10s ease infinite;
            }
        }

        .relevantProduct {
            width: 436px;
        }
    }

    /*人脸扫描动画*/
    @keyframes lineAnimate {
        from {
            top: 55px;
        }
        50% {
            top: 380px;
        }
        to {
            top: 55px;
        }
    }
</style>
